import { LinkButton } from "@climate-science/component-library";
import Card from "@cs/components/composite/card/Card";
import { Trans, useTranslation } from "next-i18next";
import { FaAngleRight } from "react-icons/fa";
import { STICKERS } from "../../const";
import styles from "./CountriesContent.module.scss";

const CountriesContent = () => {
  const {t} = useTranslation("olympiad")

  return (
    <section className={styles.sectionWrapper}>
      <h2>{t("countries.cards-sub-title")}</h2>
      <div className={styles.stickers}>
        {
          STICKERS.map((img,i) => (
            <Card key={i}
              src={img}
              index={i+1}
            >
              <p>
                <Trans
                  t={t}
                  i18nKey={t(`countries.card-${i+1}-text`)}
                  components={[
                    <strong key='0'/>
                  ]}
                />
              </p>
            </Card>
          ))
        }
      </div>
      <article className={styles.info}>
        {/* <h3>
          <Trans
            t={t}
            i18nKey={t(`countries.cards-info-subtitle-1`)}
            components={[
              <span
                key='0'
                className={styles.underline}
              />
            ]}
          />
        </h3> */}
        {/* <p>{t("countries.cards-info-text-1")}</p> */}
        <h4>{t("countries.cards-info-subtitle-2")}</h4>
        <p>{t("countries.cards-info-text-2")}</p>
        <LinkButton
          primary
          Icon={FaAngleRight}
          target="_blank"
          href="https://forms.gle/R2RLXbsagSLVs1Rz7"
        > {t("countries.cards-info-button")}
        </LinkButton>
      </article>
    </section>
  )
}

export default CountriesContent;